
        Component.define('product-item', (el, params) => {
            const $el            = $(el);
const $detail        = $el.find('.detail-title');
const $btDetail      = $el.find('.detail-title button');
const $sliderImage   = $el.find('.slider-image');
const $sliderThumb   = $el.find('.slider-thumb');
const $slidercontent = $el.find('.slider-content');

$btDetail.on('click', function () {
    const $this = $(this);
    const $parent = $this.parents('.detail-title');
    const $content = $parent.next();

    $parent.toggleClass('opened');
    $content.slideToggle();
});

$sliderImage.slick({
    infinite: false,
    arrows: false,
    swipe: false,
});

$sliderThumb.slick({
    infinite: false,
    arrows: true,
    dots: $sliderThumb.children().length > 1,

    responsive: [
        {
            breakpoint: 481,
            settings: {
                dots: false,
            }
        },
    ]
})
.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $slidercontent.slick('slickGoTo', nextSlide);
    $window.trigger('scroll');
});

$slidercontent.slick({
    infinite: false,
    arrows: false,
    swipe: false,
});

// Position top do sliderThumb
const thumbTopDefault   = $sliderThumb.css('top');
const thumbHeight       = $sliderThumb.height();
const imagePaddingTop   = parseInt($sliderImage.css('padding-top'));
let thumbTopPosition;

$window.resize(function () {
    if (wW < 480) {
        thumbTopPosition = $sliderImage.height() + imagePaddingTop - thumbHeight;
    } else {
        thumbTopPosition = thumbTopDefault;
    }

    $sliderThumb.css('top', thumbTopPosition);
}).resize();

        });